import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { NODE_TYPE_COLORS } from '@/types/docflow';
import type { INodeConfig } from '@/types/docflow';

interface ClaudeVisionNodeProps {
  data: {
    label: string;
    config: INodeConfig;
    selected?: boolean;
  };
}

const ClaudeVisionNode = memo(({ data }: ClaudeVisionNodeProps) => {
  const colors = NODE_TYPE_COLORS.claude_vision;
  const isGemini = data.config.model?.startsWith('gemini-');

  return (
    <div
      className={`px-4 py-3 rounded-lg border-2 shadow-md min-w-[180px] max-w-[220px] ${colors.bg} ${colors.border} ${
        data.selected ? 'ring-2 ring-purple-400' : ''
      }`}
    >
      <Handle
        type="target"
        position={Position.Left}
        className="w-3 h-3 !bg-purple-500"
      />

      <div className="flex items-center gap-2 mb-2">
        <svg className={`w-5 h-5 ${colors.text}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
        <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${
          isGemini
            ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200'
            : colors.badge
        }`}>
          {isGemini ? 'Gemini Vision' : 'Claude Vision'}
        </span>
      </div>

      <h4 className={`font-medium text-sm mb-1 ${colors.text}`}>
        {data.label}
      </h4>

      <div className="text-xs text-gray-500 dark:text-gray-400">
        {data.config.model || 'haiku'}
      </div>

      <Handle
        type="source"
        position={Position.Right}
        className="w-3 h-3 !bg-purple-500"
      />
    </div>
  );
});

ClaudeVisionNode.displayName = 'ClaudeVisionNode';

export default ClaudeVisionNode;
